import React from 'react';
import { CtaButton } from './CtaButton';
import { OfferCountdown } from './OfferCountdown';
import { price } from '../data/salesPage';
type PriceCardProps = {
  eyebrow: string;
  showSavings?: boolean;
};
export function PriceCard({
  eyebrow,
  showSavings = false
}: PriceCardProps) {
  return <div className="mx-auto w-full max-w-xl rounded-[2rem] border-2 border-lime bg-ink-raised p-8 text-center sm:p-12" data-id="element-167" data-mp="28qy09dsah9bi">
      <OfferCountdown data-id="element-168" data-mp="2wi3fbqqenxkr" />

      <p className="mt-8 text-xs font-bold uppercase tracking-[0.25em] text-bone-dim" data-id="element-169" data-mp="2whle0fovyt5z">Antes</p>
      <p className="mt-1 font-display text-4xl font-extrabold text-bone-muted line-through decoration-alert decoration-[4px] sm:text-5xl" data-id="element-170" data-mp="31fmtyrr0mcd8">
        <span className="sr-only" data-id="element-171" data-mp="2rhywhu20yqrd">Precio original: </span>
        {price.reference}
      </p>

      <p className="mt-8 font-display text-sm font-extrabold uppercase tracking-[0.2em] text-lime" data-id="element-172" data-mp="1b3p8x25lx61l">{eyebrow}</p>
      <p className="mt-1 font-display text-7xl font-black leading-none text-bone sm:text-8xl" data-id="element-173" data-mp="1g2k31090yh10">{price.current}</p>
      <p className="mt-4 text-base font-semibold text-bone" data-id="element-174" data-mp="3klkv0eo0169t">Acceso al programa completo</p>
      <p className="text-sm text-bone-muted" data-id="element-175" data-mp="3fnj9ln33ouv6">6 volúmenes + 6 bonos</p>

      {showSavings && <div className="mt-6 inline-flex flex-col items-center gap-1" data-id="element-176" data-mp="3tmiv4lvbgtn4">
          <span className="rounded-full bg-lime px-4 py-1.5 font-display text-base font-black uppercase text-ink" data-id="element-177" data-mp="3tkekll2wwwdv">
            Ahorrás {price.savings}
          </span>
          <span className="mt-2 text-xs font-semibold uppercase tracking-wider text-bone-muted" data-id="element-178" data-mp="7dzuk850onbl">
            Menos del 18% del valor de referencia
          </span>
        </div>}

      <div className="mt-8" data-id="element-179" data-mp="g6tdcfjoa4u7">
        <CtaButton data-id="element-180" data-mp="g7325zsze5yb" />
      </div>
    </div>;
}